export var WorkflowAssignmentsUrls = {
    GetWorkflowAssignments: "WorkflowAssignment/GetWorkflowAssignments",
    GetWorkflowState: "WorkflowAssignment/GetWorkflowState",
    Reassign: "WorkflowAssignment/Reassign",
    TakeOwnership: "WorkflowAssignment/TakeOwnership",
    ExecuteAction: "WorkflowAssignment/ExecuteAction",
    CancelWorkflow: "WorkflowAssignment/CancelWorkflow",
};
